export enum InternshipAssignmentsPermissions {
  InternshipAssignments = 'internship-assignments',
}
